export function getInitialPerson(key, ref) {
  return {
    key: key,
    ref: ref,
    firma: false,
    anrede: "kA",
    titel: null,
    firstname: null,
    lastname: null,
    strasse: null,
    hausnummer: null,
    adresszusatz: null,
    plz: null,
    ort: null,
    beruf: null,
    email: null,
    mobil: null,
    telefon: '+49',
    staat: 'Deutschland',
  };
}

export function getInitialFirma(key, ref) {
  return {
    key: key,
    ref: ref,
    firma: true,
    name: null,
    rechtsform: null,
    branche: {
      code: null,
      name: null
    },
    handelsregister: null,
    hrnummer: null,
    strasse: null,
    hausnummer: null,
    adresszusatz: null,
    plz: null,
    ort: null,
    staat: 'Deutschland',
    email: null,
    telefon: "+49",
    anzahlFilialen: null
  };
}

export function getInitialPraemie() {
  return {
    'base': 0,
    'z1': 0,
    'z2': 0,
    'z4': 0,
    'z12': 0
  };
}

export function getInitialDeckung(personKey) {
  return {
    ref: personKey,
    produkt: null,      /*['GWVERK[ABC]', 'FIRM[range]', 'MIET', 'VERMIET', 'GARAGE', 'PRIVSSR', 'KOMPEX', 'KOMPEXPLUS', 'KOMPEXSSR', 'KOMPEXPLUSSSR', '']*/
    sb: null,
    praemie: getInitialPraemie(),
    immoRef: null,       /* key of the associated Immobilie for product MIET */
    wohnRef: null,       /* key of the associated Wohnung for product SPEZ-PRIVVM */
  };
}

export function getInitialVersicherung() {
  return {
    zum: null,
    vorversicherer: null,
    vscheinnr: null,
    von: "VN"                      /*[VN,VR] gekuendigt von Versicherungsnehmer oder Versicherung*/
  };
}

export function getInitialVorversicherung(personKey) {
  return {
    ref: personKey,
    anzahlrechtsstreitigkeiten: null,
    leistungshoeherechtsstreitigkeiten: null,
    anzahlanwaltsbesuche: null,
    leistungshoeheanwaltsbesuche: null,
    streitaktuell: null,
    versicherungen: []
  };
}

export function getInitialAttachment() {
  return {
    dateiname: null,
    art: null,
    data: null
  };
}

export function getInitialMitarbeiterData() {
  return {
    vollzeit: {
      anzahl: null,
      faktor: 1
    },
    teilzeit: {
      anzahl: null,
      faktor: 0.5
    },
    sonstige: {
      anzahl: null,
      faktor: 0.25
    },
    familie: {
      anzahl: null,
      faktor: 0
    },
    inhaber: {
      anzahl: null,
      faktor: 0
    }
  };
}

export function getInitialFahrzeugData() {
  return {
    pkw: {
      flotte: 'A',
      anzahl: 0
    },
    bis4t: {
      flotte: 'A',
      anzahl: 0
    },
    bis9sitze: {
      flotte: 'A',
      anzahl: 0
    },
    zugmaschinen: {
      flotte: 'A',
      anzahl: 0
    },
    sonderfahrzeuge: {
      flotte: 'A',
      anzahl: 0
    },
    anhaenger: {
      flotte: 'C',
      anzahl: 0
    },
    ab4t: {
      flotte: 'B',
      anzahl: 0
    },
    ab9sitze: {
      flotte: 'B',
      anzahl: 0
    },
    sattelzugmaschinen: {
      flotte: 'B',
      anzahl: 0
    }
  };
}

export function getInitialImmobilie(key) {
  return {
    key: key,
    art: null,
    bezug: null,
    unit: null,
    value: null,
    name: null,
    strasse: null,
    hausnummer: null,
    plz: null,
    ort: null,
    staat: 'Deutschland'
  };
}

export function getInitialWohnung(key, personKey) {
  return {
    key: key,
    ref: personKey,
    bruttojahresmiete: null,
    strasse: null,
    hausnummer: null,
    plz: null,
    ort: null,
    staat: 'Deutschland'
  };
}

export function getInitialUIState() {
  return {
    sequentialNumber: 2,
    hasFilialen: false,
    hasMvUnternehmen: false,
    hasMvPerson: [],
    hasVorversicherung: {
      vn1: null
    },
    hasStreitigkeiten: {
      vn1: null
    },
    hasAnwaltsbesuche: {
      vn1: null
    },
    isKompex: false,
    isKompexOhneI: false,
    produkte: [],
    hideNotKompex: false,
    showKompex: false,
    showKompexOhneImmobilien: false,
    matrixSelection: {
      sb: {
        gewerbe: null,
        privat: null,
      },
      produkte: []
    },
    errorSnackbar: {
      displayerrors: false,
      timeout: null,
      closebutton: null,
      isInfo: false,
      errormessages: []
    },
    excludeGF: false,
    accordions: {
      step1Mvu: {
        uiOpenPanel: []
      },
      step1Immo: {
        uiOpenPanel: []
      },
      step2Immo: {
        uiOpenPanel: []
      },
      step2gf: {
        uiOpenPanel: [0]
      },
      step3Firma: {
        uiOpenPanel: [0]
      },
      step3Gfs: {
        uiOpenPanel: [0]
      },
      step4Vorv: {
        uiOpenPanel: [0]
      },
      step4Zweit: {
        uiOpenPanel: []
      },
      step4Wohn: {
        uiOpenPanel: []
      }
    }
  };
}

export function getInitialState() {
  return {
    deckungen: [],
    personen: [ getInitialFirma('vn1') ],     // personen also includes companies. the only difference is in the attributes of the object (see above)
    vertrag: {
      tarif: "basis",
      maknummer: "",

      submitTime: null,
      guid: null,
      angebotsnummer: null,
      pdfpfad: null,

      laufzeit: "1",                        /*[1,3] Jahre Laufzeit*/
      sb: {
        gewerbe: null,
        privat: null,
      },
      versicherungsbeginn: null,
      versicherungsbeginnvergangenheit: false,
      hauptfaelligkeit: null,
      zahlweise: "1",                        /*1=Jahr 2, 4 12=monatlich*/
      rechnungszahler: "N",
      aula: "J",
      werbezwecke: null,
      invitatio: null,
      invitatioValidation: false,
      praemie: getInitialPraemie(),
      produktcode: 'G0002'
    },
    mitarbeiter: getInitialMitarbeiterData(),
    fahrzeuge: getInitialFahrzeugData(),
    immobilien: [],
    wohnungen: [],
    ferienwohnungen: [],
    konto:{
      iban: null,
      bic: null,
      ref: "vn1"
    },
    vorversicherungen: [getInitialVorversicherung('vn1')],
    files: [],
    fileIds: [],
    anmerkungen: null,
    ui: getInitialUIState(),

    // PKS
    selectedIdentity: {
      metadata: {
        firstname: "",
        lastname: ""
      },
      username: "",
      vmnr: "",
      tarifname: ""
    }
  };
}

